/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { OTPAttestationData } from './OTPAttestationData';
import {
    OTPAttestationDataFromJSON,
    OTPAttestationDataFromJSONTyped,
    OTPAttestationDataToJSON,
    OTPAttestationDataToJSONTyped,
} from './OTPAttestationData';

/**
 * 
 * @export
 * @interface OTPAttestation
 */
export interface OTPAttestation {
    /**
     * 
     * @type {string}
     * @memberof OTPAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof OTPAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {OTPAttestationData}
     * @memberof OTPAttestation
     */
    data?: OTPAttestationData;
}



/**
 * Check if a given object implements the OTPAttestation interface.
 */
export function instanceOfOTPAttestation(value: object): value is OTPAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function OTPAttestationFromJSON(json: any): OTPAttestation {
    return OTPAttestationFromJSONTyped(json, false);
}

export function OTPAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : OTPAttestationDataFromJSON(json['data']),
    };
}

export function OTPAttestationToJSON(json: any): OTPAttestation {
    return OTPAttestationToJSONTyped(json, false);
}

export function OTPAttestationToJSONTyped(value?: OTPAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': OTPAttestationDataToJSON(value['data']),
    };
}

